"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _Overflows = require("../utils/Overflows");

var _Timers = require("../utils/Timers");

var UITruncateString =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITruncateString, _PureComponent);

  function UITruncateString(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITruncateString);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITruncateString).call(this, props));
    _this.state = {
      contentWidth: undefined,
      isTruncated: null
    };
    _this.updateTruncatedState = _this.updateTruncatedState.bind((0, _assertThisInitialized2.default)(_this));
    _this.delayedUpdateTruncatedState = _this.delayedUpdateTruncatedState.bind((0, _assertThisInitialized2.default)(_this));
    _this.wrapperRefCallback = _this.wrapperRefCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.contentRefCallback = _this.contentRefCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.tailRefCallback = _this.tailRefCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this._key = 0;
    return _this;
  }

  (0, _createClass2.default)(UITruncateString, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this._key = 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.matchContentWidth || this.props.reverse) {
        this.updateTruncatedState();
      } else {
        this.delayedUpdateTruncatedState();
      }

      window.addEventListener('resize', this.delayedUpdateTruncatedState);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Workaround for a truly bizarre Safari bug (#5825)
      var hasMaxWidth = this.props.maxWidth != null;
      var willHaveMaxWidth = nextProps.maxWidth != null;

      if (hasMaxWidth !== willHaveMaxWidth) {
        this._key = this._key + 1;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.contentWidth === this.state.contentWidth && prevState.isTruncated === this.state.isTruncated) {
        this.delayedUpdateTruncatedState();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.delayedUpdateTruncatedState);
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
    }
  }, {
    key: "updateTruncatedState",
    value: function updateTruncatedState() {
      // If the last render was caused by updateTruncatedState(), we have nothing to do.
      var wrapperEl = this._wrapperEl;
      var contentEl = this._contentEl;

      if (!wrapperEl || !contentEl) {
        return;
      }

      var _this$props = this.props,
          matchContentWidth = _this$props.matchContentWidth,
          reverse = _this$props.reverse;
      var contentWidth;

      if (matchContentWidth) {
        // We need to temporarily make the content `display: inline-block` for the width calculation.
        contentEl.style.display = 'inline-block';
        contentWidth = contentEl.clientWidth + 1;
        contentEl.style.display = '';
      }

      var isTruncated;

      if (reverse) {
        var tailEl = this._tailEl;

        if (!tailEl) {
          return;
        }

        isTruncated = (0, _Overflows.overflowsX)(tailEl, wrapperEl);
      } else {
        isTruncated = (0, _Overflows.overflowsX)(wrapperEl);
      }

      if (contentWidth !== this.state.contentWidth || isTruncated !== this.state.isTruncated) {
        this.setState({
          contentWidth: contentWidth,
          isTruncated: isTruncated
        });
      }
    }
  }, {
    key: "delayedUpdateTruncatedState",
    value: function delayedUpdateTruncatedState() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout); // Ensure only one callback is queued at a time

      this._timeout = (0, _Timers.requestSchedulerCallback)(this.updateTruncatedState);
    }
  }, {
    key: "wrapperRefCallback",
    value: function wrapperRefCallback(ref) {
      this._wrapperEl = ref;
    }
  }, {
    key: "contentRefCallback",
    value: function contentRefCallback(ref) {
      this._contentEl = ref;
    }
  }, {
    key: "tailRefCallback",
    value: function tailRefCallback(ref) {
      this._tailEl = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          fixedChildren = _this$props2.fixedChildren,
          innerClassName = _this$props2.innerClassName,
          __matchContentWidth = _this$props2.matchContentWidth,
          maxWidth = _this$props2.maxWidth,
          placement = _this$props2.placement,
          reverse = _this$props2.reverse,
          tooltip = _this$props2.tooltip,
          useFlex = _this$props2.useFlex,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "fixedChildren", "innerClassName", "matchContentWidth", "maxWidth", "placement", "reverse", "tooltip", "useFlex"]);
      var _this$state = this.state,
          contentWidth = _this$state.contentWidth,
          isTruncated = _this$state.isTruncated;
      var computedClassName = (0, _classnames.default)('private-truncated-string', className, {
        'private-truncated-string--is-flex': useFlex,
        'private-truncated-string--has-tooltip': Boolean(isTruncated)
      }); // When maxWidth is set, we need to set maxWidth on both the outer container and the inner
      // wrapper. We also need to set width to "unset" (if we aren't using matchContentWidth) in
      // order to prevent the table column from collapsing to 0 due to the `width: 100%` rule.

      var computedMaxWidth = maxWidth && contentWidth ? Math.min(maxWidth, contentWidth) : maxWidth || contentWidth;
      var style = computedMaxWidth ? {
        maxWidth: computedMaxWidth,
        width: maxWidth ? 'unset' : undefined
      } : undefined;
      var tailClassName = (0, _classnames.default)('private-truncated-string__reverse__tail', {
        'is-truncated': isTruncated
      });
      var renderedContent = reverse ? _react.default.createElement("span", {
        className: "private-truncated-string__reverse"
      }, isTruncated ? _react.default.createElement("span", {
        className: "private-truncated-string__reverse__ellipse"
      }, "\u2026") : null, _react.default.createElement("span", {
        className: tailClassName
      }, _react.default.createElement("span", {
        className: "private-truncated-string__reverse__content",
        ref: this.tailRefCallback
      }, children))) : children;
      return _react.default.createElement(_UITooltip.default, {
        disabled: tooltip === false || isTruncated === false,
        placement: placement,
        title: typeof tooltip === 'boolean' ? children : tooltip
      }, _react.default.createElement("span", (0, _extends2.default)({}, rest, {
        className: computedClassName,
        key: this._key,
        style: style
      }), _react.default.createElement("span", {
        className: (0, _classnames.default)('private-truncated-string__inner', innerClassName),
        ref: this.wrapperRefCallback,
        style: style
      }, _react.default.createElement("span", {
        ref: this.contentRefCallback
      }, renderedContent)), fixedChildren));
    }
  }]);
  return UITruncateString;
}(_react.PureComponent);

exports.default = UITruncateString;
UITruncateString.propTypes = {
  children: _propTypes.default.node.isRequired,
  fixedChildren: _propTypes.default.node,
  innerClassName: _propTypes.default.string,
  matchContentWidth: _propTypes.default.bool.isRequired,
  maxWidth: _propTypes.default.number,
  placement: _UITooltip.default.propTypes.placement,
  reverse: _propTypes.default.bool.isRequired,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node, _propTypes.default.string]).isRequired,
  useFlex: _propTypes.default.bool.isRequired
};
UITruncateString.defaultProps = {
  placement: _UITooltip.default.defaultProps.placement,
  reverse: false,
  tooltip: true,
  matchContentWidth: false,
  useFlex: false
};
UITruncateString.displayName = 'UITruncateString';
module.exports = exports.default;